import React from 'react';
import PropTypes from 'prop-types';
import {getState as getComponentPreloadState} from '../utils/preloadState';
import Slide from '../containers/Slide';

import './PresentationWrapper.css';

const touchX = e => e.changedTouches[0].clientX;

class PresentationWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {slideDistance: []};
    this.el = React.createRef();
    this.locked = false;

    let initialTouchX;
    let activeSlideIndex;

    this.touchStart = e => {
      initialTouchX = touchX(e);
      this.isTouching = true;
      this.el.current.classList.remove('animate');
      activeSlideIndex = this.props.slideIndex;
    };

    this.touchMove = e => {
      if (this.isTouching) {
        this.el.current.style.setProperty('--tx', `${Math.round(touchX(e) - initialTouchX)}px`);
      }
    };

    this.touchEnd = e => {
      if (!this.isTouching) {
        return;
      }
      this.isTouching = false;

      const differenceX = touchX(e) - initialTouchX;
      const s = Math.sign(differenceX); // forward or back one slide (1 or -1)
      let f = + s * differenceX / window.innerWidth;

      if ((activeSlideIndex > 0 || s < 0) && (activeSlideIndex < this.props.slide_order.length - 1 || s > 0) && f > .2) {
        activeSlideIndex -= s;
        f = 1 - f;
      }

      this.el.current.style.setProperty('--animation-time', (f / 2).toFixed(2) + 's');
      this.el.current.classList.add('animate');
      this.el.current.style.setProperty('--tx', '0px');

      if (activeSlideIndex !== this.props.slideIndex) {
        this.el.current.style.setProperty('--i', activeSlideIndex);
        setTimeout(this.props.setSlideIndex, (f / 2) * 1000, activeSlideIndex);
      }
    };
  }

  componentDidMount() {
    this.el.current.style.setProperty('--i', this.props.slideIndex);
  }

  componentDidUpdate() {
    if (this.props.slideIndex.toString() !== this.el.current.style.getPropertyValue('--i')) {
      this.el.current.classList.add('animate');
      this.el.current.style.setProperty('--animation-time', '.4s');
      this.el.current.style.setProperty('--i', this.props.slideIndex);
    }
  }

  static getDerivedStateFromProps(props, state) {
    state.slideDistance = props.slide_order.map((id, i) => i - props.slideIndex);
    return state;
  }

  render() {
    const slides = [];

    this.props.slide_order.forEach((slideId, i) => {
      const distance = Math.abs(i - this.props.slideIndex);
      const preloadState = getComponentPreloadState(distance);
      slides.push(<Slide index={i} id={slideId} key={slideId} distance={this.state.slideDistance[i]} preloadState={preloadState} />);
    });

    const style = {
      '--n': this.props.slide_order.length
    };

    return (
      <div className="PresentationWrapper">
        <div
          className="Presentation"
          ref={this.el}
          style={style}
          onTouchStart={this.touchStart}
          onTouchMove={this.touchMove}
          onTouchEnd={this.touchEnd}
        >
          {slides}
        </div>
      </div>
    );
  }
}

PresentationWrapper.defaultProps = {
  slideIndex: 0,
  slide_order: []
};

PresentationWrapper.propTypes = {
  setSlideIndex: PropTypes.func.isRequired,
  slideIndex: PropTypes.number,
  slide_order: PropTypes.array
};

export default PresentationWrapper;
